import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";
import { errorToast } from '../../../utils/toasts';

const { GET_SUMMARY_SUCCESS, GET_SUMMARY_FAIL, GET_DETAILS_SUCCESS, GET_DETAILS_FAIL } = ActionTypes.REPORTS.CAN_PACKET_HEALTH;
const { GET_SUMMARY, GET_DETAILS } = API_BOOK.REPORTS.CAN_PACKET_HEALTH;

/* Action dispatchers */

const getSummarySuccessAD = (payload) => ({
  type: GET_SUMMARY_SUCCESS,
  payload,
});

const getSummaryFailAD = () => ({
  type: GET_SUMMARY_FAIL
});

const getDetailsSuccessAD = (payload) => ({
  type: GET_DETAILS_SUCCESS,
  payload,
});

const getDetailsFailAD = () => ({
  type: GET_DETAILS_FAIL
});

/* Actions */

export const GetCanPacketHealthSummary = ({ date, city, oemAndModels, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_SUMMARY.method,
      url: GET_SUMMARY.url,
      data: { date, city, oemAndModels, pageSize, pageIndex }
    });
    if (resp.status === 200 && resp?.data?.data) {
      dispatch(getSummarySuccessAD(resp.data.data));
    } else {
      dispatch(getSummaryFailAD());
      errorToast('Failed to fetch CAN packet health summary');
    }
  } catch (error) {
    dispatch(getSummaryFailAD());
    errorToast('Failed to fetch CAN packet health summary');
  }
};

export const GetCanPacketHealthDetails = ({ registrationNumber, date }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_DETAILS.method,
      url: GET_DETAILS.url,
      data: { registrationNumber, date }
    });
    if (resp.status === 200 && resp?.data?.data) {
      dispatch(getDetailsSuccessAD(resp.data.data));
    } else {
      dispatch(getDetailsFailAD());
      errorToast('Failed to fetch CAN packet health details');
    }
  } catch (error) {
    dispatch(getDetailsFailAD());
    errorToast('Failed to fetch CAN packet health details');
  }
};
